import React from 'react';
import PropTypes from 'prop-types';
import { useContentstackAPI } from '../../../hooks/use-contentstack-api';

import PackagePanel from '../../template/product/package-panel';
import SwatchesPanel from '../../template/product/swatches-panel';

const InterstackFNO = ({ data }) => {
	const { content, status } = useContentstackAPI(data, '&include[]=package&include[]=package.image&include[]=screens&include[]=video&include[]=options_images&include[]=single_image');

	if (status !== 'success') return null;

	if (content?.[0]?.special_type === 'package') return <PackagePanel data={content[0]} />;
	if (content?.[0]?.options_images?.[0]) return <SwatchesPanel data={content} />;

	return null;
};

InterstackFNO.propTypes = {
	data: PropTypes.array.isRequired,
};

export default InterstackFNO;
